<template>
  <div class="left-box" style="height: calc(100vh - 204px);">
    <div class="left-title">
      <span style="cursor: pointer;" @click="titleClick">{{title}}</span>
    </div>
    <div class="left-main">
      <el-tree
        ref="tree"
        :data="treeData"
        :node-key="treeKey"
        :default-expand-all="true"
        :props="defaultProps"
        :check-on-click-node="true"
        :expand-on-click-node="false"
        @node-click="onSelect"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span class="label" :title="node.label" :class="{'current-node':node.isCurrent}">
            <span>{{data.DpNo}} {{node.label}}</span>
          </span>
        </span>
      </el-tree>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    treeKey: {
      type: String,
      default: "DpId",
    },
    treeLabel: {
      type: String,
      default: "DpName",
    },
    title: {
      type: String,
      default: "组织架构",
    },
    delText: {
      type: String,
      default: "确定删除这个部门吗？",
    },
    showAction: {
      type: String,
      default: () => "Create|Edit|Delete",
    },
    parentClick: {
      type: Boolean,
      default: () => true,
    },
    autoH: {
      type: Boolean,
      default: false,
    },
    isDrawer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      api: require("@/api/ent/dp").default,
      treeData: [],
      defaultProps: {
        children: "children",
        label: this.treeLabel,
      },
      nowId: null,
      visible: false,
      menu: {
        top: 0,
        left: 0,
        selectedTag: {},
      },
    };
  },
  watch: {
    visible(value) {
      if (value) {
        document.body.addEventListener("click", this.closeMenu);
      } else {
        document.body.removeEventListener("click", this.closeMenu);
      }
    },
  },
  mounted() {
    // this.getData({});
  },
  methods: {
    titleClick() {
      console.log("title-click");
      this.$emit("title-click");
      this.resetSelect();
    },
    getData(params = {}) {
      params = { ...params };
      this.api.list(params).then((res) => {
        // console.log("tree_getData", res);
        this.treeData = this.$commonJs.toTreeData(res.Data, this.treeKey);
        // if (this.treeData.length > 0) {
        //   this.nowId = this.treeData[0][this.treeKey];
        // }
        // // console.log("treeData", this.treeData, this.treeKey);
        // this.$nextTick(() => {
        //   this.$refs.tree.setCurrentKey(this.nowId);
        //   if (this.nowId != null) this.$emit("on-select", this.treeData[0]);
        // });
      });
    },
    resetSelect() {
      this.setKey(null);
    },
    setKey(key) {
      this.$refs.tree.setCurrentKey(key);
    },
    onSelect(node, self) {
      if (this.parentClick) {
        this.nowId = node[this.treeKey];
        this.$emit("on-select", node);
      } else {
        if (node.children != undefined) {
          self.isCurrent = false;
        } else {
          this.nowId = node[this.treeKey];
          this.$emit("on-select", node);
        }
      }
    },
  },
};
</script>